import { ChainAddressType as M } from "../../constants/chain.js";
import { WalletType as S } from "../../constants/web3.js";
import T from "../generic/useChainSwitcher.js";
import W from "../web3/useWeb3.js";
import I from "../../util/misc/date.js";
import { useCallback as c } from "react";
import { useTranslation as k } from "react-i18next";
import { SiweMessage as v } from "siwe";
const H = () => {
  const { t: l } = k(), { getChainType: p, getWalletProvider: d } = T(), { signRequest: a, connectWallet: u } = W(), i = c((t) => {
    const { message: e, network: s, provider: n, timestamp: r } = t, o = btoa(
      JSON.stringify({
        network: s,
        wallet: n,
        timestamp: r
      })
    );
    return `${e} @${o}`;
  }, []), w = c(
    async (t) => {
      const { wallet: e } = t, s = i(t), n = await a(s, e);
      return {
        message: s,
        signature: n
      };
    },
    [i, a]
  ), y = c(
    async (t) => {
      const { wallet: e, timestamp: s } = t, { address: n, chainId: r } = await u({
        walletType: e,
        networkType: e === S.Metamask ? M.POLYGON : M.RONIN
      }), o = I({
        timestamp: s * 1e3,
        formatMethod: "yyyy-MM-dd'T'HH:mm:ssXXX"
      }), m = i(t), g = {
        address: n.toString(),
        chainId: r,
        domain: window.location.host,
        issuedAt: o,
        statement: m,
        uri: window.location.origin,
        version: "1"
      }, f = new v(g).toMessage(), h = await a(f, e);
      return { message: f, signature: h };
    },
    [u, i, a]
  );
  return {
    getBindWalletInput: c(
      async (t) => {
        const e = p(t), s = d(t), n = Math.floor(Date.now() / 1e3), o = window.location.protocol === "http:" ? w : y, { message: m, signature: g } = await o({
          message: l("login.signature_statement"),
          network: e,
          provider: s,
          timestamp: n,
          wallet: t
        });
        return {
          message: m,
          messageTimestamp: n,
          network: e,
          provider: s,
          signature: g
        };
      },
      [p, d, w, y, l]
    )
  };
};
export {
  H as default
};
//# sourceMappingURL=useGetBindWalletInput.js.map
